module.exports = __webpack_public_path__ + "static/media/aws-ec2.e1266524.svg";